import React, { useState } from 'react'
import './ModalEditBill.scss'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Calendar from 'react-calendar'
import { FaCalendar } from 'react-icons/fa'
import {updateLocalBill} from '../../../../../../../../../../../../crud/management_api/local_bills'
import { X } from 'react-bootstrap-icons'

interface ModalEditBillProps {
  show: boolean;
  onHide: () => void;
  onSave: (data: any) => void;
  initialData: {
    bill_name: string;
    amount: number;
    bill_date: string;
    bill_number: number;
    file?: string;
  };
}

const ModalEditBill: React.FC<ModalEditBillProps> = ({ show, onHide, onSave, initialData }) => {
  const [billName, setBillName] = useState(initialData.bill_name || '');
  const [billAmount, setBillAmount] = useState(initialData.amount?.toString() || '');
  const [billNumber, setBillNumber] = useState(initialData.bill_number?.toString() || '');
  // Inicialización de selectedDate para evitar desfase de día
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    initialData.bill_date
      ? (() => {
          const [year, month, day] = initialData.bill_date.split('-').map(Number);
          return new Date(year, month - 1, day);
        })()
      : null
  );
  const [showCalendar, setShowCalendar] = useState(false);
  const [files, setFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);

  // Sincronizar los valores cuando cambie initialData (cuando se selecciona otro bill para editar)
  React.useEffect(() => {
    setBillName(initialData.bill_name || '');
    setBillAmount(initialData.amount?.toString() || '');
    setBillNumber(initialData.bill_number?.toString() || '');
    setSelectedDate(
      initialData.bill_date
        ? (() => {
            const [year, month, day] = initialData.bill_date.split('-').map(Number);
            return new Date(year, month - 1, day);
          })()
        : null
    );
    setFiles([]); // No se cargan archivos previos
  }, [initialData]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFiles(Array.from(e.target.files));
    }
  };

  const renderFilePreviews = () => {
    return files.map((file, index) => {
      const isImage = file.type.startsWith('image');
      return (
        <div key={index} className="file-preview">
          {isImage ? (
            <div className="file-preview-text">
              <i className="file-preview-icon">🖼️</i> {file.name}
            </div>
          ) : (
            <div className="file-preview-text">
              <i className="file-preview-icon">📄</i> {file.name}
            </div>
          )}
        </div>
      );
    });
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      // Se asume que initialData tiene el id de la factura (por ejemplo, bill_id)
      // Si no, deberás ajustar para recibirlo como prop
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const billId = (initialData as any).bill_id;
      const updatedData = {
        bill_name: billName,
        amount: parseFloat(billAmount),
        bill_number: parseInt(billNumber, 10),
        bill_date: selectedDate ? `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}` : '',
        file: files.length > 0 ? files[0].name : initialData.file || null,
        files,
      };
      await updateLocalBill(billId, updatedData);
      onSave(updatedData);
    } catch (error) {
      // Puedes mostrar un toast aquí si lo deseas
      console.error('Error al actualizar la factura', error);
    } finally {
      setLoading(false);
      onHide();
    }
  };

  const toggleCalendar = () => setShowCalendar((prev) => !prev);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Editar Pago</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form className="add-bill-form mb-4">
          <Form.Group className="mp-formgroup horizontal" controlId="billName">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nombre del pago"
              value={billName}
              onChange={(e) => setBillName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mp-formgroup horizontal" controlId="billAmount">
            <Form.Label>Monto</Form.Label>
            <Form.Control
              type="number"
              placeholder="Monto a pagar"
              value={billAmount}
              onChange={(e) => setBillAmount(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="dob" className="mp-formgroup horizontal fecha">
            <Form.Label>Fecha</Form.Label>
            <Button
              variant="no"
              onClick={toggleCalendar}
              className="boton-show-calendar"
            >
              {selectedDate ? selectedDate.toLocaleDateString() : ''} <FaCalendar />
            </Button>
          </Form.Group>
          <div className="calendar-container calendario-create-user">
            {showCalendar && (
              <div className='mp-form-calendar-container'>
                <Calendar
                  onChange={(date) => {
                    // Forzar la fecha local para evitar desfase
                    const d = date as Date;
                    const localDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
                    setSelectedDate(localDate);
                    setShowCalendar(false);
                  }}
                  value={selectedDate}
                  locale="es-ES"
                  className="mp-form-calendar"
                />
              </div>
            )}
          </div>

          <Form.Group className="mp-formgroup horizontal" controlId="billNumber">
            <Form.Label>Número de Factura</Form.Label>
            <Form.Control
              type="number"
              placeholder="Número de factura"
              value={billNumber}
              onChange={(e) => setBillNumber(e.target.value)}
            />
          </Form.Group>

          {/* <Form.Group className="mediopunto-multi-file-upload" controlId="billFiles">
            <Form.Label>Archivos</Form.Label>
            <Form.Control
              type="file"
              multiple
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={handleFileChange}
            />
            {renderFilePreviews()}
          </Form.Group> */}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className='form-button-cancel' onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="none" className='form-button-create' onClick={handleSave} disabled={loading}>
          {loading ? 'Guardando...' : 'Guardar Cambios'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEditBill;